import React from 'react';

import type Review from 'pages/open-course/peerReview/reviewTypes/structured/models/review';
import TeamInlineFeedbackModal from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/boxAnnotation/components/TeamInlineFeedbackModal';
import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/boxAnnotation/models/schema';

import Content from 'bundles/phoenix/components/Content';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/BoxAnnotationDisplayPart';

type Props = {
  // @ts-expect-error ts-migrate(4033) FIXME: Property 'reviewSchemaPart' of exported interface ... Remove this comment to see the full error message
  reviewSchemaPart: ReviewSchemaPart;
  // @ts-expect-error ts-migrate(4033) FIXME: Property 'reviews' of exported interface has or is... Remove this comment to see the full error message
  reviews: Array<Review>;
};

type State = {
  showModal: boolean;
};

class BoxAnnotationDisplayPart extends React.Component<Props, State> {
  state = {
    showModal: false,
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  };

  render() {
    const { reviewSchemaPart, reviews } = this.props;
    const { showModal } = this.state;
    const reviewPartId = reviewSchemaPart.id;
    const responseId = reviews[0].get('parts').get(reviewPartId).get('responseId');
    return (
      <div className="rc-BoxAnnotationDisplayPart">
        <Content assumeStringIsHtml={false} content={reviewSchemaPart.get('prompt')} />
        <button type="button" className="primary" onClick={this.toggleModal}>
          {_t('See More Feedback')}
        </button>
        {/*
        // @ts-expect-error TSMIGRATION */}
        {showModal && <TeamInlineFeedbackModal reviewResponseId={responseId} onCloseModal={this.toggleModal} />}
      </div>
    );
  }
}

export default BoxAnnotationDisplayPart;
